import { render, staticRenderFns } from "./ProfileWhoMarkedMeFavoriteReveals.vue?vue&type=template&id=3f5892df&scoped=true&"
import script from "./ProfileWhoMarkedMeFavoriteReveals.vue?vue&type=script&lang=js&"
export * from "./ProfileWhoMarkedMeFavoriteReveals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5892df",
  null
  
)

export default component.exports